import { useEffectOnce } from "react-use";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { Card, CodeValidationForm, Layout } from "../components";
import { useRegistration } from "../hooks/use-registration";
import { safeTrackEvent, verificationViewEvent } from "../tracking/events";

export const SimplifyRegistration = () => {
  const { handleRegistration, registerError, createOrderError, isLoading } = useRegistration();

  useEffectOnce(() => {
    safeTrackEvent(
      () => verificationViewEvent({ method: "guest" }),
      "verification_view",
      "simplify-registration mount",
    );
  });

  return (
    <IntersectionFadeIn>
      <Layout>
        <Card>
          <CodeValidationForm
            onSubmit={handleRegistration}
            error={registerError || createOrderError}
            isLoading={isLoading}
            method="guest"
          />
        </Card>
      </Layout>
    </IntersectionFadeIn>
  );
};
